<template>
	<div>
		<div class="modal fade" data-backdrop="static" id="mdNewTarefa">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">
							Exibir tarefa
						</h4>
					</div>
					<div class="modal-body">
						<div class="well well-sm">
							<div class="row">
								<div class="col-sm-8">
									<span>Tarefa</span>
									<input
										type="text"
										v-model="data.tarefa"
										class="form-control"
									/>
								</div>
								<div class="col-sm-4">
									<span>Tipo Tarefa</span>
									<select
										class="form-control"
										v-model="data.tiptarefa"
									>
										<option value="c">Contratual</option>
										<option value="a">Avulsa</option>
									</select>
								</div>
							</div>
						</div>

						<ul class="nav nav-tabs">
							<li
								@click="active = 's'"
								:class="active == 's' ? 'active' : ''"
							>
								<a>Configurações</a>
							</li>
							<!-- <li @click='active = "f"' :class='active == "f" ? "active" : ""'>
				  		<a>Formulários</a>
				  </li> -->
						</ul>

						<AppSettings
							v-if="active == 's'"
							:dIn="data"
							:sequenciar="sequenciar"
							@seq="(val) => (sequenciar = val)"
						/>
					</div>
					<div class="modal-footer">
						<div class="pull-left">
							<label class="checkbox-inline">
								<input type="checkbox" v-model="sequenciar" />
								Sequênciar dias uteis
							</label>
						</div>
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-tasks"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import AppSettings from './components/configuracao.vue';
	import aBtn from 'btn';
	import clone from 'js/clone';
	import WBS from 'js/http';
	import toastr from 'toastr';
	let reset = {
		tarefa: '',
		tiptarefa: 'c',
		iniciar: 0,
		duracao: 0,
		recorrencia: 365 * 24 * 60,
		evento: '',
	};

	export default {
		name: 'ModalTarefa',
		components: { AppSettings, aBtn },
		data() {
			return {
				data: clone(reset),
				active: 's',
				sequenciar: false,
			};
		},
		computed: {},
		methods: {
			save() {
				WBS.send('private-save-tasks', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#mdNewTarefa').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
			open(data) {
				if (data == undefined) this.data = clone(reset);
				else this.data = clone(data);
				jQuery('#mdNewTarefa').modal('show');
			},
		},
	};
</script>
<style scoped>
	.nav-tabs li a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/tasks/modal.vue